module.exports = __webpack_public_path__ + "img/obs_water_caution_down.3454e5a0.svg";